<template>
  <!--使用方法 <IShare :imgSrc="require('../imgs/h5_share_friend@2x.png')" /> -->
  <div class="share_wrap" @click="close" v-if="isShare">
    <div class="guide" :style="styleStr">
      <img :src="imgSrc" alt="">
      <img src="./images/close.png" class="close" alt="">
      <span v-if="cardId">ID：{{cardId}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isShare: {
      type: Boolean,
      default: false
    },
    cardId: String,
    imgSrc: String,
    imgPos: {
      type: Object,
      default() {
        return {
          show: false,
          top: 0,
          right: 0
        };
      }
    }
  },
  data() {
    return {
      styleStr: '',
      showShare: false
    };
  },
  methods: {
    close() {
      this.$parent.$data.isShare = false;
      this.$emit('closeClick');
    }
  },
  mounted() {
    if (this.imgPos.show) {
      this.styleStr = 'position:absolute; top:' + this.imgPos.top + 'px; right:' + this.imgPos.right + 'px;';
    }
  }
};
</script>
<style lang="stylus" scoped>
.share_wrap {
  width 100%;
  height 100%;
  position fixed;
  left 0;
  top: 0;
  text-align center;
  background rgba(0, 0, 0, .8);
  .guide {
    width 263px
    height 290px
    margin 0 auto
    position relative
    img {
      width 100%
      height 100%
    }
    .close{
      width: 50px
      height 50px
      display block
      margin 20px auto
    }
    span {
      display block
      width 100%
      text-align center
      font-size 12px
      color #A2500A
      height 20px
      line-height 20px
      position absolute
      bottom 15px
      left 0
    }
  }

}
</style>
